
    import I18n from 'i18nObj';
    
      import 'translations/canvas_modal';
      import 'translations/_core';
    
    import 'translations/_core_en';

    export default I18n.scoped('canvas_modal');
  